import { render, staticRenderFns } from "./Infobox.vue?vue&type=template&id=45383b90&"
import script from "./Infobox.vue?vue&type=script&lang=js&"
export * from "./Infobox.vue?vue&type=script&lang=js&"
import style0 from "./Infobox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports